import { RecurrenceDaysOfWeekEnum } from '../../../api/generated';

// Discriminators on the polymorphic BookingTime payload. The generated client types `kind` as a
// plain `string`, so it is not inferred — we set it explicitly when building a request. The
// per-subtype booking `type` discriminators (e.g. ROOM, STAFF) live with each feature.
export const SINGLE_OCCURRENCE_KIND = 'SINGLE' as const;
export const RECURRING_OCCURRENCES_KIND = 'RECURRING' as const;

export const DEFAULT_INTERVAL_WEEKS = 1;

export interface WeekdayOption {
  day: RecurrenceDaysOfWeekEnum;
  shortLabelKey: string;
}

/** Mon–Sun display order with the translation key for each day's short name. */
export const WEEKDAYS_IN_ORDER: readonly WeekdayOption[] = [
  { day: RecurrenceDaysOfWeekEnum.Monday, shortLabelKey: 'weekday-short-mon' },
  { day: RecurrenceDaysOfWeekEnum.Tuesday, shortLabelKey: 'weekday-short-tue' },
  { day: RecurrenceDaysOfWeekEnum.Wednesday, shortLabelKey: 'weekday-short-wed' },
  { day: RecurrenceDaysOfWeekEnum.Thursday, shortLabelKey: 'weekday-short-thu' },
  { day: RecurrenceDaysOfWeekEnum.Friday, shortLabelKey: 'weekday-short-fri' },
  { day: RecurrenceDaysOfWeekEnum.Saturday, shortLabelKey: 'weekday-short-sat' },
  { day: RecurrenceDaysOfWeekEnum.Sunday, shortLabelKey: 'weekday-short-sun' }
];
